module.exports = __webpack_public_path__ + "static/media/Credits-34.3ab89493.pdf";